module.exports = __webpack_public_path__ + "img/logo_back.c25cee31.jpg";